import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import { ssoClient } from "@better-auth/sso/client";
import { twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { stripLoginOnlyParams } from "@/lib/post-login-redirect";

export const authClient = createAuthClient({
  baseURL: process.env.BUN_PUBLIC_API_URL,
  plugins: [
    twoFactorClient({
      onTwoFactorRedirect: () => {
        // Redirect to the 2FA verification page, keeping the login query
        // (?redirect=, MCP OAuth params) so the verify page can finish the
        // round trip to the requested URL — e.g. a standalone flow link (QL-261).
        const query = stripLoginOnlyParams(new URLSearchParams(window.location.search)).toString();
        window.location.href = query ? `/login/verify-2fa?${query}` : "/login/verify-2fa";
      },
    }),
    ssoClient(),
    // Sends the signed OAuth request (`sig` query of the login/consent page) with
    // better-auth calls so an MCP authorization can be resumed (oauth2.consent).
    oauthProviderClient(),
  ],
});

// Convenience hook — everything else is called via `authClient.*` directly
export const { useSession } = authClient;

/**
 * Slug of the tenant a session belongs to. `tenantSlug` is an additional
 * session field set by the API (better-auth.ts) that the client does not infer.
 */
export function getSessionTenantSlug(data: { session: unknown } | null | undefined): string | null {
  const slug = (data?.session as { tenantSlug?: unknown } | undefined)?.tenantSlug;
  return typeof slug === "string" && slug !== "" ? slug : null;
}
